module.exports = {
  siteTitle: 'LENZIFY', // <title>
  manifestName: 'Overflow',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-overflow/`, // This path is subpath of your hosting https://domain/portfolio
  authorName: 'LENZIFY',
  heading: 'Digital & Startup Advisors',
  // social
  socialLinks: [
    {
      icon: 'fa-linkedin',
      name: 'LinkedIN',
      url: 'https://www.linkedin.com/in/mattfhall/',
      alt: 'LinkedIN'
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:matt@lenzify.com',
      alt: 'Email'
    },
  ],
};
